export default __webpack_public_path__ + "static/media/vid1.4208b868.png";